import getHints from './getHints'

export const quantificationUnits = {
  getHints,
}
